import { Queries } from 'lib/core/services/magento/queries'

export const configureMagentoQueries = (queries: Queries) => {
  // @ts-expect-error
  queries.cartQuery.items.prices = {
    total_item_discount: {
      value: true
    },
    price: {
      value: true
    },
    row_total_including_tax: {
      value: true
    },
    row_total: {
      value: true
    }
  }
  // @ts-expect-error
  queries.cartQuery.items.frequency_in_cart = true
  // @ts-expect-error
  queries.cartQuery.items.promo_qty = true
  // @ts-expect-error
  queries.cartQuery.items.package_qty = true
  // @ts-expect-error
  queries.cartQuery.items.associated_promo_hash = true
  queries.customerQuery.customer.community = {
    community_id: true,
    code: true,
    name: true
  }
  queries.customerQuery.customer.customer_type = true
  queries.getCmsPagesQuery.getCmsPages.items.meta_title = true
  queries.postsQuery.posts.items.meta_title = true
  queries.postsQuery.posts.items.meta_description = true
}
